import SXMLink from '@/shared-components/SXMLink';
import { Text } from '@/ui-components/atoms/Text/Text';
import IconExternalLink from '@/assets/icons/icon-external-link.svg';
import styles from './searchresult.module.scss';
import cn from 'classnames';
import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';

// If there is a need in a future for such a LinkWithIcon somewhere else, this could be a standalone component.
function LinkWithIcon({ href, aria_label, link_target, link_text }: Link) {
    return (
        <SXMLink className={styles.link} href={href ?? ''} aria-label={aria_label} target={link_target}>
            <Text className={styles.linkText} tag="p">
                {link_text}
            </Text>
            <IconExternalLink className={styles.arrowIcon} />
        </SXMLink>
    );
}

interface SearchResultProps {
    label: string;
    title: string;
    titleLink: Link;
    mainText?: string;
    bottomLinkText?: string;
    bottomLink?: Link;
    thumbnailSrc?: string;
    variant: 'list' | 'card';
    labelPosition?: 'after_title';
    className?: string;
    titleClassName?: string;
    onClick?: React.MouseEventHandler;
}

export default function SearchResult({
    label,
    title,
    titleLink,
    mainText,
    bottomLink,
    bottomLinkText = 'Launch in player',
    thumbnailSrc,
    variant = 'list',
    labelPosition,
    className,
    titleClassName,
    onClick,
}: SearchResultProps): React.JSX.Element {
    const ariaLabel = `Launch ${title} in player: opens in new tab`;
    const isCardVariant = variant === 'card';

    const linkClasses = cn(styles.bottomLink, {
        [styles.linkWithIconWrapper]: isCardVariant,
    });

    const cardVariantStyling = cn(className, {
        [styles.cardMainContainer]: isCardVariant,
        [styles.mainContainer]: !isCardVariant,
    });

    return (
        <div className={cardVariantStyling}>
            <div className={styles.textContainer}>
                {'after_title' === labelPosition && (
                    <>
                        <SXMLink
                            className={styles.titleLink}
                            href={titleLink?.href ?? ''}
                            aria-label={ariaLabel}
                            onClick={onClick}
                        >
                            <Text tag="h2" variant="h5" className={titleClassName ?? styles.title}>
                                {title}
                            </Text>
                        </SXMLink>
                        <Text className={styles.label} tag="p">
                            {label}
                        </Text>
                    </>
                )}
                {'after_title' !== labelPosition && (
                    <>
                        <Text className={styles.label} tag="p">
                            {label}
                        </Text>
                        <SXMLink
                            className={styles.titleLink}
                            href={titleLink?.href ?? ''}
                            aria-label={ariaLabel}
                            onClick={onClick}
                        >
                            <Text tag="h2" variant="h5" className={titleClassName ?? styles.title}>
                                {title}
                            </Text>
                        </SXMLink>
                    </>
                )}

                {mainText && (
                    <Text className={isCardVariant ? styles.cardMainText : styles.mainText} tag="p">
                        {mainText}
                    </Text>
                )}
                {bottomLinkText && bottomLink?.href && (
                    <div className={linkClasses}>
                        <LinkWithIcon href={bottomLink?.href ?? ''} link_text={bottomLinkText} aria_label={ariaLabel} />
                    </div>
                )}
            </div>
            {!isCardVariant && thumbnailSrc && (
                <div className={styles.imageContainer}>
                    <ImageWrapper src={thumbnailSrc} alt={title} />
                </div>
            )}
        </div>
    );
}
